export default __webpack_public_path__ + "static/media/gauge.374bd906.png";